// extracted by mini-css-extract-plugin
export var allpressReleaseContainer = "index-module--allpressReleaseContainer--f9NrZ";
export var paginationContainer = "index-module--paginationContainer--0uRaz";
export var pressReleaseBannerContainer = "index-module--pressReleaseBannerContainer--m2HsU";
export var pressReleaseBannerContent = "index-module--pressReleaseBannerContent--pa4Ak";
export var pressReleaseContent = "index-module--pressReleaseContent--qbpgx";
export var pressReleaseContentContainer = "index-module--pressReleaseContentContainer--L+MmM";
export var pressReleaseTagsContainer = "index-module--pressReleaseTagsContainer--wPS6n";